module.exports = __webpack_public_path__ + "img/gerb-big.f87221ee.png";